import React, {useEffect} from 'react';
import BBDataTable from "../../tables/BBDataTable";
import {useDispatch, useSelector} from "react-redux";
import {fetchCustomers} from "../../../../actions";
import {renderCellExpand} from "../../tables/DataGridRenderCellExpand";
import {
    bbDangerousStringToDate,
    bbDoesCustomerHaveAccessToSubscription,
    bbFindCustomerTagsById,
    bbFormattedDateString
} from "../../../../util/bbHelpers";
import {BRCustomizedTooltip as Tooltip} from "../../accents/BRCustomizedTooltip";
import BRSubscriptionControlWidget from "./BRSubscriptionControlWidget";
import BBIconCheckCircleYes from "../../../../assets/bbCustomIcons/BBIconCheckCircleYes";
import BBIconRoundedDashNull from "../../../../assets/bbCustomIcons/BBIconRoundedDashNull";
import BBIconContinuous from "../../../../assets/bbCustomIcons/BBIconContinuous";
import {HashLink as Link} from "react-router-hash-link";
import CustomerEarlyAccessControl from "./CustomerEarlyAccessControl";
import {customersData} from "../../../../app/routes/dashboard/routes/settingsSubscription/tempTestDataForCustomers";
import UpdateCustomerNameDialog from "./UpdateCustomerNameDialog";


const BRCustomersTable = (props) => {

    const { customers, loadingCustomers } = useSelector(({customer})=> customer);
    // const {loadingCustomers} = useSelector(({customer})=> customer);

    // const customers = customersData;
    const dispatch = useDispatch();

    useEffect(()=>{
        if(!customers && !loadingCustomers){
            dispatch(fetchCustomers());
        }
    }, [customers, loadingCustomers]);


    const allCustomersArray = customers ? Object.values(customers) : null;

    allCustomersArray
    && Array.isArray(allCustomersArray)
    && allCustomersArray.sort((a,b)=>{
        const textA = a.CustomerName.toUpperCase();
        const textB = b.CustomerName.toUpperCase();
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });


    // const customersWithBRSub = allCustomersArray && allCustomersArray.filter((customer)=>
    //     Object.keys(customer.Subscriptions).length > 0);

    // const customersWithBRSub = allCustomersArray && allCustomersArray.filter((customer)=>{
    //     const customerSubs = customer && Object.keys(customer.Subscriptions);
    //
    //     return customerSubs
    //         && Array.isArray(customerSubs)
    //         && customerSubs.length > 0
    // });

    const tableData = customers
        && allCustomersArray
        && Array.isArray(allCustomersArray)
        && allCustomersArray.map((customer)=>{
            const now = Date.now();

            const customerSubs = customer && customer.Subscriptions;
            const customerSubsArray = customer
                && customerSubs
                && Object.values(customerSubs);

            const activeSubsOnly = customer
                && customerSubsArray
                && Array.isArray(customerSubsArray)
                && customerSubsArray
                    .filter((sub)=> !sub.subscription_end || (sub.subscription_end && bbDangerousStringToDate(sub.subscription_end) > now));
            // console.log(customerSubs)

            const brBizSubArray = customer
                && customerSubsArray
                && Array.isArray(customerSubsArray)
                && customerSubsArray
                .filter((sub)=> sub && sub.subscription_type && sub.subscription_type.id === 2 );
            // console.log(brBizSub)
            const brBizSub = brBizSubArray
            && brBizSubArray
                .find(x => !x.subscription_end|| (x.subscription_end && bbDangerousStringToDate(x.subscription_end) > now))
                ? brBizSubArray
                    .find(x => !x.subscription_end|| (x.subscription_end && bbDangerousStringToDate(x.subscription_end) > now))
                : null;

            const brPortSubArray = customer
                && customerSubsArray
                && Array.isArray(customerSubsArray)
                && customerSubsArray
                .filter((sub)=> sub && sub.subscription_type && sub.subscription_type.id === 1 );

            const brPortSub = brPortSubArray
            && brPortSubArray
                .find(x => !x.subscription_end|| (x.subscription_end && bbDangerousStringToDate(x.subscription_end) > now))
                ? brPortSubArray
                    .find(x => !x.subscription_end|| (x.subscription_end && bbDangerousStringToDate(x.subscription_end) > now))
                : null;

            const providedSubs = customer
                && customerSubsArray
                && Array.isArray(customerSubsArray)
                && customerSubsArray
                    .filter((sub)=> sub && sub.customer_provided );
            // && sub.customer_provided !== sub.customer

            const hasProvidedSubs = providedSubs && providedSubs.length > 0;

            const stromboli = customer && customer.Stromboli;

            const earlyAccessTags = bbFindCustomerTagsById(customer, 54);

            const selfManagedSubs = customerSubsArray
                && customerSubsArray
                    .filter((sub)=>sub.stripe_subscription_id)

            const BRBizManagedByStripe = customer && customer.BRBManagedByStripe;
            const BRPortManagedByStripe = customer && customer.BRPManagedByStripe;


            return{
            ...customer,
            id: customer.CustomerId,
            // hasBRBiz: brBizSubArray && brBizSubArray.length > 0,
            hasBRBiz: bbDoesCustomerHaveAccessToSubscription(customer, 2),
            brBizSub: brBizSub,
            // hasBRPort: brPortSubArray
            //     && brPortSubArray.length > 0,
            hasBRPort: bbDoesCustomerHaveAccessToSubscription(customer, 1),
            brPortSub: brPortSubArray
                && brPortSubArray.length > 0
                ? brPortSub : null,
            hasCIRT: customer && customer.Stromboli && customer.Stromboli["Service Active"] === "1",
            brBizStartDate: brBizSubArray
                        && brBizSubArray.length > 0
                        ? brBizSub.subscription_start  : null ,
            brBizEndDate: brBizSubArray
                        && brBizSubArray.length > 0
                        ? brBizSub.subscription_end : null,
            brPortStartDate: brPortSubArray
                        && brPortSubArray.length >0
                        ? brPortSubArray[0].subscription_start : null,
            brPortEndDate: brPortSubArray
                        && brPortSubArray.length >0
                        ? brPortSubArray[0].subscription_end : null,
            hasContAttacksEnabled: !!(customer.Stromboli && customer.Stromboli["Service Active"] === "1"),
            cirtStartDate: !!stromboli ? customer["Subscription StartDate"] : null,
            cirtEndDate: !!stromboli ? customer["Subscription EndDate"] : null,
            hasEarlyAccess: earlyAccessTags && earlyAccessTags.length > 0,
            hasProvidedSubs: hasProvidedSubs,
            hasSelfManagedSubs: BRPortManagedByStripe || BRBizManagedByStripe,
        }
    })

    // console.log(tableData);

    const columnHeadings = [

        // { field: 'Customer Short Name', headerName: 'Company Name', hide: false, width : 150, sortable: true, type: 'string',
        //     renderCell: (params) =>
        //         renderCellExpand(params,(<span>{params.value}</span>))},
        { field: 'CustomerName', headerName: "Company Name", hide: false, flex: 1, sortable: true, type: "string",
            renderCell: (params)=>
                renderCellExpand(params,
                    (<UpdateCustomerNameDialog customerId={params.row.CustomerId}>
                            <Link to={params.row.hasCIRT ? `/board/CIRT/external?clientID=${params.row.CustomerId}` : `/board/BreachRisk/Business/Report/TechData?clientID=${params.row.CustomerId}`}>
                                {params.value}
                            </Link>
                        </UpdateCustomerNameDialog>))},
        {field: 'CreatedDate', headerName: 'Created ', hide: true, width: 140, sortable: true, type: 'string',
            renderCell: (params) =>
                renderCellExpand(params, (bbFormattedDateString(params.value, "short"))),
        },
        {field: 'CustomerId', headerName: 'Id ', hide: false, width: 100, sortable: true, type: 'string',
            renderCell: (params) =>
                renderCellExpand(params, (<small>{params.value}</small>)),
        },
        { field: 'CustomerPocName', headerName: 'Point Of Contact', hide: true, flex: 1, sortable: true, type: 'string',
            renderCell: (params) =>
                renderCellExpand(params,(
                    <small><monospace> {params.value} : {params.row.CustomerPocEmail}</monospace></small>
                    )
                )},
        { field: 'StatusId', headerName: 'Status Id', hide: true, width : 50, sortable: true, type: 'string',
            renderCell: (params) =>
                renderCellExpand(params,(params.value))},
        { field: 'hasProvidedSubs', headerName: 'Provided', hide: false, width : 50, sortable: true, type: 'string',
            renderHeader: params =>
                <Tooltip title={"Subscription Provided By Another Company"}>
                    <span>
                        <BBIconCheckCircleYes className={'text-default'}/>
                    </span>
                </Tooltip>,
            renderCell: (params) =>
                renderCellExpand(params,(
                    params.value
                    ?<Tooltip title={`Subscription Provided By`}>
                        <span className={"text-center"}>
                            <BBIconCheckCircleYes className={'text-primary'}/>
                        </span>
                        </Tooltip>
                        :<Tooltip title={`Not A Provided By Subscription`}>
                        <span>
                            <BBIconRoundedDashNull/>
                         </span>
                        </Tooltip>
                ))},
        { field: 'hasBRBiz', headerName: 'hasBRBiz', hide: false, width:160, sortable: true, type: 'boolean',
            renderHeader: params => <></>,
            renderCell: (params) =>
                renderCellExpand(params,
                    <span>
                         <BRSubscriptionControlWidget
                            customerId={params.row.CustomerId}
                            subscriptionTypeName={"Business"}
                            subscriptionType={2}
                            hasSubscription={params.value}
                            // subscriptions={params.value ? params.row.brBizSub : null}
                         />
                        </span>

                )},
        { field: 'brBizStartDate', headerName: 'Start', hide: false, width : 110, sortable: true, type: 'dateTime',
            renderCell: (params) =>
                renderCellExpand(params,(params.value ? bbFormattedDateString(params.value, "short") : "--"))},
        { field: 'brBizEndDate', headerName: 'End', hide: false, width : 110, sortable: true, type: 'dateTime',
            renderCell: (params) =>
                renderCellExpand(params,(params.value ? bbFormattedDateString(params.value, "short") : "--"))},
        { field: 'hasBRPort', headerName: 'hasBRPort ', hide: false, width:160, sortable: true, type: 'boolean',
            renderHeader: params => <></>,
            renderCell: (params) =>
                renderCellExpand(params,
                    ( <BRSubscriptionControlWidget
                            customerId={params.row.CustomerId}
                            subscriptionTypeName={"Portfolio"}
                            subscriptionType={1}
                            // hasSubscription={params.value}
                            // subscriptions={params.value ? params.row.brPortSub : null}
                    />)
                )},
        { field: 'brPortStartDate', headerName: 'Start', hide: false, width: 110, sortable: true, type: 'dateTime',
            renderCell: (params) =>
                renderCellExpand(params,(params.value ? bbFormattedDateString(params.value, "short") : "--"))},
        { field: 'brPortEndDate', headerName: 'End', hide: false, width : 110, sortable: true, type: 'dateTime',
            renderCell: (params) =>
                renderCellExpand(params,(params.value ? bbFormattedDateString(params.value, "short") : "--"))},
        { field: 'hasCIRT', headerName: 'hasCIRT ', hide: true, width:100, sortable: true, type: 'boolean',
            renderHeader: params => <></>,
            renderCell: (params) =>
                renderCellExpand(params,
                    ( <BRSubscriptionControlWidget
                        customerId={params.row.CustomerId}
                        subscriptionTypeName={"CIRT"}
                        subscriptionType={3}
                        // hasSubscription={params.value}
                        // subscriptions={null}
                    />)
                    // (params.value
                    //     ? <Badge color="primary">CIRT</Badge>
                    //     : <Badge>CIRT</Badge>)
                )},
        { field: 'hasContAttacksEnabled', headerName: "Continuous Attacks", hide:true, width: 60, sortable: false, type: 'boolean',
            renderHeader: (params =>
                <Tooltip title={`CIRT Continuous Attacks Capabilities`}>
                    <span>
                        <BBIconContinuous/>
                    </span>
                </Tooltip>),
        renderCell: params =>
            renderCellExpand(params,
                params.value
                    ?<Tooltip title={`Continuous Attacks Active`}>
                        <span className={"text-center"}>
                            <BBIconCheckCircleYes className={'text-bb-risk-low'}/>
                        </span>
                    </Tooltip>
                    :<Tooltip title={`Continuous Attacks Inactive`}>
                        <span>
                            <BBIconRoundedDashNull/>
                         </span>
                    </Tooltip>)},
        { field: 'cirtStartDate', headerName: 'Start', hide: true, width:110, sortable: true, type: 'dateTime',
            renderCell: (params) =>
                renderCellExpand(params,(params.value ? bbFormattedDateString(params.value, "short") : "--"))},
        { field: 'cirtEndDate', headerName: 'End', hide: true, width : 110, sortable: true, type: 'dateTime',
            renderCell: (params) =>
                renderCellExpand(params,(params.value ? bbFormattedDateString(params.value, "short") : "--"))},
        { field: 'hasEarlyAccess', headerName: "Early Access", hide:false, width: 110, sortable: true, type: 'boolean',
            renderHeader: (params =>
                <Tooltip title={``}>
                    <span>
                        Early Access
                    </span>
                </Tooltip>),
            renderCell: params =>
                renderCellExpand(params,
                    (
                    <Tooltip title={``}>
                        <span className={"text-center"}>
                            <CustomerEarlyAccessControl customerId={params.row.CustomerId}/>
                         </span>
                        </Tooltip>))},
        { field: 'hasSelfManagedSubs', headerName: 'Self-managed', hide: true, width : 150, sortable: true, type: 'string',
            renderCell: (params) =>
                renderCellExpand(params,(<span>{params.value ? "True" : "False"}</span>))},

    ]

    return(
        <div className={"app-main-content ripple-effect"} style={{padding: "1.5rem"}}>
            {(customers &&
                !loadingCustomers)
                ?
                <BBDataTable
                    columns={columnHeadings}
                    rows={tableData}
                    defaultPageSize={100}
                    title={"Customers with BR Subscriptions"}
                    loading={false}
                    progressValue={100}
                    bufferValue={100}
                    defaultSortModel = {[

                        {
                            field: 'CustomerName',
                            sort: 'asc',
                        },

                ]}
                />
                :
                <BBDataTable
                    columns={columnHeadings}
                    rows={[]}
                    defaultPageSize={50}
                    title={"Customers with BR Subscriptions"}
                    loading = {true}
                    />
            }
        </div>
    )
}

export default BRCustomersTable;